// Header.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import NotificationBanner from './NotificationBanner';
import HeaderSearch from './HeaderSearch';
import NavigationMenu from './NavigationMenu';

const Header = () => {
  return (
    <>
      {/* Notification Banner */}
      <NotificationBanner />

      {/* Header */}
      <header className="bg-light border-bottom">
        <div className="container">
          <div className="py-3 d-flex flex-column gap-3">
            {/* Search */}
            <div className="d-flex align-items-center gap-4">
              <div className="flex-grow-1">
                <HeaderSearch />
              </div>
            </div>

            {/* Navigation */}
            <NavigationMenu />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;